import { render, staticRenderFns } from "./icon-salary.vue?vue&type=template&id=eba153b0&scoped=true"
var script = {}
import style0 from "./icon-salary.vue?vue&type=style&index=0&id=eba153b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eba153b0",
  null
  
)

export default component.exports